'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../../../constants/colors');

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_React$Component) {
    _inherits(Edit, _React$Component);

    function Edit(props) {
        _classCallCheck(this, Edit);

        var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

        _this.getIcon = function () {
            return _react2.default.createElement(
                'svg',
                { width: '20px', height: '20px', viewBox: '0 0 22 22', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
                _react2.default.createElement(
                    'g',
                    { id: 'atom/icon/pencil/default', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
                    _react2.default.createElement(
                        'g',
                        { fill: _this.state.hover ? _colors.Colors.StrokeVeryDark : _colors.Colors.StrokeDark },
                        _react2.default.createElement('path', { d: 'M14.1382,2.3863 C14.5112,2.7593 14.5112,3.3693 14.1382,3.7413 L3.1262,14.7543 C2.7532,15.1273 2.1432,15.1273 1.7702,14.7543 C1.3982,14.3813 1.3982,13.7713 1.7702,13.3993 L12.7832,2.3863 C13.1562,2.0133 13.7652,2.0133 14.1382,2.3863', id: 'Fill-1' }),
                        _react2.default.createElement('path', { d: 'M19.3052,7.5533 C19.6782,7.9263 19.6782,8.5353 19.3052,8.9083 L8.2922,19.9213 C7.9202,20.2933 7.3102,20.2933 6.9372,19.9213 C6.5642,19.5483 6.5642,18.9383 6.9372,18.5653 L17.9502,7.5533 C18.3222,7.1803 18.9322,7.1803 19.3052,7.5533', id: 'Fill-3' }),
                        _react2.default.createElement('path', { d: 'M2.6685,13.1661 C3.1825,13.2831 3.5065,13.8001 3.3895,14.3131 L1.8925,20.8721 C1.7755,21.3861 1.2585,21.7101 0.7455,21.5931 C0.2305,21.4761 -0.0935,20.9591 0.0235,20.4451 L1.5215,13.8871 C1.6385,13.3731 2.1545,13.0491 2.6685,13.1661', id: 'Fill-5' }),
                        _react2.default.createElement('path', { d: 'M8.5312,19.0489 C8.6462,19.5629 8.3202,20.0779 7.8062,20.1939 L1.1912,21.6799 C0.6772,21.7959 0.1612,21.4689 0.0462,20.9549 C-0.0698,20.4409 0.2572,19.9259 0.7712,19.8099 L7.3852,18.3239 C7.9002,18.2079 8.4152,18.5339 8.5312,19.0489', id: 'Fill-8' }),
                        _react2.default.createElement('path', { d: 'M17.2788,9.5665 C16.9048,9.1925 16.9048,8.5855 17.2788,8.2115 L18.9458,6.5435 C20.0228,5.4665 20.0458,3.7365 18.9968,2.6885 C17.9478,1.6395 16.2178,1.6625 15.1408,2.7385 L13.4738,4.4065 C13.0998,4.7805 12.4928,4.7805 12.1188,4.4065 C11.7438,4.0315 11.7438,3.4245 12.1188,3.0505 L13.7858,1.3835 C15.6108,-0.4405 18.5558,-0.4635 20.3528,1.3325 C22.1488,3.1295 22.1258,6.0745 20.3018,7.8995 L18.6338,9.5665 C18.2598,9.9415 17.6538,9.9415 17.2788,9.5665', id: 'Fill-10' }),
                        _react2.default.createElement('path', { d: 'M18.8823,8.4595 C18.5093,8.8325 17.9003,8.8325 17.5273,8.4595 L13.2253,4.1575 C12.8533,3.7855 12.8533,3.1755 13.2253,2.8025 C13.5983,2.4305 14.2083,2.4305 14.5813,2.8025 L18.8823,7.1045 C19.2553,7.4775 19.2553,8.0865 18.8823,8.4595', id: 'Fill-13' }),
                        _react2.default.createElement('polygon', { id: 'Fill-15', points: '2.3574 20.7818 0.9434 19.3678 2.2984 18.0118 3.7124 19.4268' })
                    )
                )
            );
        };

        _this.state = {
            hover: false
        };
        return _this;
    }

    _createClass(Edit, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { onMouseEnter: function onMouseEnter() {
                        return _this2.setState({ hover: true });
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this2.setState({ hover: false });
                    },
                    onClick: this.props.clickEvent
                },
                this.getIcon()
            );
        }
    }]);

    return Edit;
}(_react2.default.Component);

exports.default = Edit;